import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeleteProductAttributeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DeleteCoreProductAttributeInput;
}>;

export type DeleteProductAttributeMutationResult = { __typename?: 'Mutation' } & {
  deleteCoreProductAttribute: { __typename?: 'DeleteCoreProductAttributePayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const DeleteProductAttributeDocument = gql`
  mutation deleteProductAttribute($input: DeleteCoreProductAttributeInput!) {
    deleteCoreProductAttribute(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
